module.exports = __webpack_public_path__ + "img/initials_yellow.ae8ff852.svg";